export const FORM_SCREEN = 'FORM_SCREEN';
export const SUCCESS_SCREEN = 'SUCCESS_SCREEN';
